<template>
  <header>
    <div id="header" class="header_fixed" @click="loginAlert = false">
      <div class="content">
        <div class="top flex">
          <div class="logos cursorP">
            <img
              src="~/static/login/logo.png"
              alt=""
              title="中国残联就业创业平台"
              class="imgs"
              @click="goRouters('/')"
            />
            <div class="cursorP" @click="citys = true">
              {{ location }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
          <div class="rights cursorP">
            <div class="search" @click="isHide = true">
              <img src="../../static/login/search_green.png" alt="" />
            </div>
            <div class="flexa">
              <a
                href="javascript:void(0);"
                title="盲人朋友在线浏览按住Alt+g键"
                class="asscess"
                @click="ShowDetail"
                v-if="false"
              >
                <!-- <img src="../../static/public/accessible.png" alt /> -->
                <p>无障碍</p>
              </a>
              <div class="phone">
                <img
                  src="../../static/login/mobile.png"
                  alt=""
                  class="paddR10"
                />
                <div class="phoneQr">
                  <ul>
                    <li>
                      <p>APP下载</p>
                      <img src="@/static/public/apps.png" alt="app二维码" />
                    </li>
                    <li>
                      <p>公众号</p>
                      <img src="@/static/public/wechat.jpg" alt="app二维码" />
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="!status"></div>
              <div class="messsage" v-else @click="messageHandle">
                <el-badge
                  :value="count"
                  class="item"
                  style="position: absolute; top: -12px; right: 0"
                  v-if="count != 0"
                ></el-badge>
                <p class="flexs changegree">消息</p>
                <div class="box" v-show="shows" @mouseleave="shows = false">
                  <div class="messages" v-if="type == 1">
                    <div class="tops">
                      <ul class="tabcard flex">
                        <li
                          v-for="(item, index) in tab"
                          :key="index"
                          :class="{ active: active == index }"
                          @click="tabs(index)"
                        >
                          {{ item }}
                        </li>
                      </ul>
                      <div class="center">
                        <div v-if="active == 0" class="list">
                          <ul>
                            <li
                              class="line_clamp1 flexa"
                              v-for="item in messageList.touDi"
                              :key="item.id"
                            >
                              <el-badge
                                dge
                                is-dot
                                class="item"
                                v-if="item.isSee == 0"
                              ></el-badge>
                              <router-link
                                :to="item.path ? item.path : ''"
                                targe="_blank" @click.native="changeStatusById(item.id)"
                                >{{ item.noticeMsgJson.msgJson }}
                              </router-link>
                            </li>
                          </ul>
                          <div
                            class="no_messages"
                            v-if="
                              messageList.touDi == null ||
                              messageList.touDi.length == 0
                            "
                          >
                            <img src="@/static/message/no_message.png" alt />
                          </div>
                        </div>
                        <div v-if="active == 1" class="list">
                          <ul>
                            <li
                              class="line_clamp1"
                              v-for="item in messageList.yaoQing"
                              :key="item.id"
                            >
                              <el-badge
                                is-dot
                                class="item"
                                v-if="item.isSee == 0"
                              ></el-badge>
                              <router-link
                                :to="item.path ? item.path : ''"
                                target="_blank" @click.native="changeStatusById(item.id)"
                                >{{ item.noticeMsgJson.msgJson }}
                              </router-link>
                            </li>
                          </ul>
                          <div
                            class="no_messages"
                            v-if="
                              messageList.yaoQing == null ||
                              messageList.yaoQing.length == 0
                            "
                          >
                            <img src="@/static/message/no_message.png" alt />
                          </div>
                        </div>
                        <div v-if="active == 2" class="list">
                          <ul v-if="messageList">
                            <li
                              class="line_clamp1"
                              v-for="item in messageList.xiTong"
                              :key="item.id"
                            >
                              <el-badge
                                is-dot
                                class="item"
                                v-if="item.isSee == 0"
                              ></el-badge>
                              <router-link
                                to="/messages/?active=3"
                                target="_blank"  @click.native="changeStatusById(item.id)"
                                >{{ item.noticeMsgJson.msgJson }}
                              </router-link>
                            </li>
                          </ul>
                          <div
                            class="no_messages"
                            v-if="
                              messageList.xiTong == null ||
                              messageList.xiTong.length == 0
                            "
                          >
                            <img src="@/static/message/no_message.png" alt />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="foot">
                      <p @click="read">全部标记为已读</p>
                      <router-link to="/messages/" target="_blank">
                        <p>更多内容</p>
                      </router-link>
                    </div>
                  </div>
                  <div class="messages" v-if="type == 2">
                    <div class="tops">
                      <ul class="tabcard flex">
                        <li class="active">系统通知</li>
                      </ul>
                      <div class="center">
                        <div class="list" v-if="messageList">
                          <ul>
                            <li
                              class="line_clamp1"
                              v-for="item in messageList.xiTong"
                              :key="item.id"
                            >
                              <el-badge
                                is-dot
                                class="item"
                                v-if="item.isSee == 0"
                              ></el-badge>
                              <router-link
                                :to="item.path ? item.path : ''"
                                tag="span"
                                >{{ item.noticeMsgJson.msgJson }}
                              </router-link>
                            </li>
                          </ul>
                          <div
                            class="no_messages"
                            v-if="
                              messageList.xiTong == null ||
                              messageList.xiTong.length == 0
                            "
                          >
                            <img src="@/static/message/no_message.png" alt />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="foot">
                      <p @click="read">全部标记为已读</p>
                      <router-link to="/messages/" target="_blank">
                        <p>更多内容</p>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="user" v-if="!status">
                <!--                <router-link  :to = "{path:'/Login',query:{id:'geren'}}">登录/注册</router-link>-->
                <div class="login_user" @mouseover="loginAlert = true">
                  <el-button type="primary">
                    登录
                    <el-divider direction="vertical"></el-divider>
                    注册
                  </el-button>
                </div>
              </div>
              <div class="user" v-else>
                <div class="imgs">
                  <img :src="logo" alt class="imgs err_avatar" />
                </div>
                <HeadDrop></HeadDrop>
              </div>
              <!-- 下拉 -->

              <!--              <div class="enterprise flexs" v-if="status == 1">-->
              <!--                <img src="../../static/login/company.png" alt />-->
              <!--                <router-link to="/user/companyLogin" >进入企业版</router-link>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
        <div class="index_tab">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo tab_el_memu"
            mode="horizontal"
            :router="true"
            v-if="type == 1 || touristType == 1"
          >
            <el-menu-item index="/">
              <div class="li">首页</div>
            </el-menu-item>
            <el-menu-item index="/job/">
              <div class="li">求职招聘</div>
            </el-menu-item>
            <el-menu-item index="/training/">
              <div class="li">职业培训</div>
            </el-menu-item>
            <el-menu-item index="/asklib/">
              <div class="li">问答社区</div>
            </el-menu-item>
            <el-menu-item index="/section/">
              <div class="li">专栏</div>
            </el-menu-item>
            <el-menu-item index="/news/">
              <div class="li">政策要闻</div>
            </el-menu-item>
            <el-submenu index="/activity_inline/">
              <template slot="title" active-text-color="#333333">活动</template>
              <el-menu-item index="/activity_inline/">线上活动</el-menu-item>
              <el-menu-item index="/activity_outline/">线下活动</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo tab_el_memu"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
            v-if="type == 2"
          >
            <el-menu-item index="/enterprise">
              <div class="li">首页</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/post">
              <div class="li">职位管理</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/recruiting">
              <div class="li">找人才</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/resumes">
              <div class="li">简历管理</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/netJob">
              <div class="li">网络招聘会</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/ask">
              <div class="li">问答社区</div>
            </el-menu-item>
            <el-menu-item index="/enterprise/section">
              <div class="li">专栏</div>
            </el-menu-item>
            <el-submenu index="/enterprise/activity_inline" class="online">
              <template slot="title" active-text-color="#333333">活动</template>
              <el-menu-item index="/enterprise/activity_inline"
                >线上活动
              </el-menu-item>
              <el-menu-item index="/enterprise/activity_outline"
                >线下活动
              </el-menu-item>
            </el-submenu>
            <!--            <el-menu-item index="/enterprise/3">商城</el-menu-item>-->
          </el-menu>
        </div>
        <div class="login_alert" v-show="loginAlert">
          <el-button type="primary" @click="goRouters('/Login')"
            ><img src="~/static/login/user1.png" alt="" />我要求职</el-button
          >
          <el-button
            type="primary"
            class="blue"
            @click="goRouters('/user/companyLogin')"
            ><img src="~/static/login/company1.png" alt="" />我要招聘</el-button
          >
          <a
            href="https://admin.cdpee.org.cn/"
            target="_blank"
            @click="loginAlert = false"
          >
            <el-button type="waring" class="org"
              ><img src="~/static/login/jigou1.png" alt="" />机构登录</el-button
            >
          </a>
        </div>
      </div>

      <div class="weimu" v-if="isHide" @mouseover="isHide = false"></div>
      <div
        class="zhehao weimu"
        v-show="loginAlert"
        @mouseover="loginAlert = false"
      ></div>
      <transition name="el-zoom-in-top">
        <div class="search-box" v-if="isHide" @click="isHide = true">
          <div class="search_content">
            <h2>搜索</h2>
            <el-input
              placeholder="请输入您想搜索的 职位或公司"
              v-model="search"
              class="search_input"
            >
              <el-button
                type="primary"
                slot="append"
                @click="goRouter('/job/', search)"
                >搜索
              </el-button>
            </el-input>
            <div class="keyword">
              热门搜索：
              <a
                v-for="item in hotlist"
                :key="item.id"
                href="javascript:void(0);"
                @click="hotHandle('/job/', item.name, item.id)"
                >{{ item.name }}</a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <city :show="citys" width="1000px" @close="handleClose"></city>
    <disLogin
      :goShow="isHideLogin"
      @close="handleClose"
      title="残疾人登录"
      :text="title"
    ></disLogin>
  </header>
</template>

<script>
import city from "@/components/search/allCity";
import HeadDrop from "./HeadDrop";
import disLogin from "@/components/login/disLogin";

export default {
  name: "Header",
  props: {
    index: "",
  },
  inject: ["reload"],
  components: {
    city,
    HeadDrop,
    disLogin,
  },
  data() {
    return {
      title: "",
      status: "",
      logo: "",
      userName: "",
      messageList: [],
      no_message: 0,
      readType: 3,
      count: 0,
      isLogin: "",
      activeName: "活动",
      options: [
        {
          value: "1",
          label: "职位",
        },
        {
          value: "2",
          label: "公司",
        },
      ],
      tab: ["投递反馈", "面试邀请", "系统通知"],
      active: 0,
      isHide: false,
      shows: false,
      loginAlert: false,
      location: "全国站",
      select: "全部",
      search: "",
      activeIndex: this.$route.path || "",
      type: 1,
      touristType: "",
      citys: false,
      isHideLogin: false,
      hotlist: [],
    };
  },
  computed: {
    locationItem() {
      return this.$store.state.location;
    },
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/job/") {
          return (this.select = "职位");
        } else {
          return (this.select = "全部");
        }
      },
      // 深度观察监听
      deep: true,
    },
    locationItem(state, info) {
      let text = localStorage.getItem("locationText");
      let locationSelect = localStorage.getItem("locationSelect");
      if (locationSelect) {
        this.location = locationSelect;
      } else {
        this.location = text;
      }
    },
  },
  methods: {    //单条数据已读
    changeStatusById(val){
      this.$api.changeReadStatusById({id:val})
    },
    handleSelect(key, keyPath) {
      // this.reload();
    },
    messageHandle() {
      this.shows = true;
    },
    ShowDetail() {
      if (window.top.document.getElementById("rrbay_toolbar_div")) {
        return false;
      }
      var url = "?url=" + document.location.href;
      window.scrollTo(0, 0);
      this.location_href("canyou/default.html" + url);
    },
    // 热门关键词
    async v2hotSearchWord(val) {
      let res = await this.$api.v2hotSearchWord({ pageSize: 6 });
      this.hotlist = res.data;
    },
    hotHandle(url, name, id) {
      this.$api.v2hotSearchWordHits({ id: id });
      const { href } = this.$router.resolve({
        path: url,
        query: {
          active: name,
        },
      });
      window.open(href, "_blank");
    },
    //通知消息
    async message() {
      this.$api
        .messageApi({ pageSize: 5 })
        .then((res) => {
          if (res.data) {
            this.no_message = 1;
            this.messageList = res.data.data;
            this.$api.queryUserMsgCount().then((res) => {
              this.count = res.data.zong;
            });
          } else {
            this.no_message = 0;
          }
        })
        .catch((err) => {
          this.no_message = 0;
        });
    },
    //一键已读
    read() {
      this.$api.readsApi("all").then((res) => {
        if (res.data.success) {
          this.$message.success("刷新成功！！");
        }
        this.message();
      });
    },
    location_href(url) {
      location.href = url;
    },
    // handChange(val) {
    //     localStorage.setItem('codeAlert', 'codeAlert');
    // },
    selectLink() {
      if (this.$route.path == "/job/") {
        return (this.select = "职位");
      } else {
        return (this.select = "全部");
      }
    },
    tabs(i) {
      this.active = i;
      if (i == 0) {
        this.readType = 3;
      } else if (i == 1) {
        this.readType = 4;
      } else {
        this.readType = 2;
      }
    },
    handleClose() {
      this.citys = false;
      this.isHideLogin = false;
    },
    goRouter(url, name) {
      const { href } = this.$router.resolve({
        path: url,
        query: {
          active: name,
        },
      });
      window.open(href, "_blank");
      this.loginAlert = false;
    },
    goRouters(url) {
      this.$router.push(url);
    },
  },
  created() {
    if (this.$store.state.userType || localStorage.getItem("userType")){
      let login = this.$store.state.userType || JSON.parse(localStorage.getItem("userType"));
      this.logo = login.logo;
      this.status =
          this.$store.state.userType || login.userType;
      this.type = this.$store.state.userType.userType || login.userType || 1;
      this.touristType = this.$store.state.userType.touristType;
      this.message();


    }
    setTimeout(() => {
      this.selectLink();
      this.activeIndex = this.index || this.$route.path;
    }, 10);
    let text = localStorage.getItem("locationText") || "全国站";
    let locationSelect = localStorage.getItem("locationSelect");
    if (locationSelect) {
      this.location = locationSelect;
    } else {
      this.location = text;
    }
    this.v2hotSearchWord();
  },
  mounted() {},
};
</script>

<style scoped lang="less">
header {
  position: relative;
  min-height: 119px;

  /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    font-weight: bold;
    color: #333333;
    font-size: 16px;

    i {
      font-weight: bold;
      color: #333333;
    }
  }

  .content {
    position: relative;
    width: 1200px;
    margin: 0 auto;

    .top {
      margin-bottom: 5px;
      padding-top: 15px;

      .logos {
        display: flex;
        align-items: center;

        .imgs {
          width: 359px;
          height: 39px;
          // background: url("../../static/login/logo.png") center center
          //   no-repeat;
          // background-size: 359px 39px;
          margin-right: 12px;

          img {
            width: 100%;
            height: 100%;
          }

          .el-icon-caret-bottom {
            color: #333333;
          }
        }
      }

      .rights {
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        margin-left: 20px;

        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }

        .search {
          display: flex;
          padding-left: 25px;
          height: 30px;
          align-items: center;
          border-left: 1px solid #999999;

          svg {
            width: 30px;
          }

          svg:hover path {
            fill: #00924c;
          }
        }

        .messsage {
          padding: 0 14px;
          position: relative;

          .changegree:hover {
            color: #00924b;
          }

          .box {
            width: 390px;
            height: 400px;
            position: absolute;
            top: 20px;
            z-index: 11111;
            right: -180px;
          }

          .no_messages {
            width: 370px;
            height: 100%;
            background: url("../../static/message/borders.png") center center
              no-repeat;
            background-size: 370px 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            p {
              color: #00924b;
              font-size: 12px;
            }
          }

          .messages {
            width: 370px;
            max-height: 352px;
            top: 6px;
            position: absolute;
            left: 20px;
            background: url("../../static/message/borders.png") center center
              no-repeat;
            background-size: 370px auto;
            display: flex;
            flex-direction: column;

            .tops {
              flex: 1;
              display: flex;
              flex-direction: column;
            }

            .tabcard {
              display: flex;
              margin-top: 27px;
              justify-content: space-around;
              padding-bottom: 10px;
              border-bottom: 1px solid #e1e1e1;

              li {
                font-size: 16px;
              }
            }

            .center {
              height: 252px;

              .no_messages {
                background: white;
                height: 252px;
              }

              .list {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                ul {
                  width: 340px;

                  li {
                    width: 340px;
                    height: 50px;
                    text-align: left;
                    line-height: 50px;
                    padding: 0px 10px;

                    .item {
                      top: -5px;
                      left: -4px;
                    }

                    span {
                      color: #666666;
                    }

                    span:hover {
                      color: #00924c;
                    }

                    border-bottom: 1px solid #e1e1e1;
                  }

                  li:last-child {
                    border: none;
                  }
                }
              }
            }

            .foot {
              height: 40px;
              width: 368px;
              margin: auto;
              border-radius: 0px 0px 6px 6px;
              display: flex;
              box-sizing: border-box;
              justify-content: space-between;
              padding: 0 15px;
              align-items: center;
              background: #edfef1;

              p:first-child {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
              }

              p:last-child {
                font-size: 14px;
                color: #666666;
              }

              p:hover {
                font-size: 14px;
                color: #00924c;
              }
            }
          }
        }

        /*.messsage:hover .box {*/
        /*display: block;*/
        /*}*/

        .user {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 20px 0;

          .imgs {
            width: 22px;
            height: 22px;
            margin-right: 10px;
            border-radius: 50%;
          }

          .el-divider--vertical {
            background: #00924b;
          }

          img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 50%;
          }

          a {
            color: #00924b;
          }

          p {
            width: 100px;
            overflow: hidden;
          }
        }

        .enterprise {
          margin-left: 10px;

          a {
            color: #00924b;
          }

          img {
            display: block;
            width: 22px;
            height: 22px;
            margin-right: 5px;
          }
        }

        .phone {
          width: 25px;
          height: 20px;
          display: flex;
          align-items: center;
          // margin: 0px 20px;
          position: relative;

          img {
            display: block;
            position: relative;
          }
        }

        .phone:hover .phoneQr {
          display: block;
        }

        .phoneQr {
          position: absolute;
          top: 25px;
          right: -120px;
          width: 262px;
          height: 190px;
          background: url("../../static/public/kuang.png") center center
            no-repeat;
          background-size: 262px 100%;
          z-index: 999;
          align-items: center;
          justify-content: space-around;
          display: none;

          ul {
            width: 262px;
            display: flex;
            height: 190px;
            align-items: center;
            justify-content: space-around;

            li {
              text-align: center;

              p {
                margin-bottom: 14px;
              }

              img {
                display: block;
                width: 100px;
              }
            }
          }
        }

        .asscess {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            display: block;
            margin-right: 6px;
          }

          a {
            color: #666;
          }
        }
      }
    }
  }

  .index_tab {
    position: relative;

    .tab_el_memu {
      width: 1200px;
      margin: 0 auto;
      border: none;
      display: flex;

      .el-menu-item,
      .el-submenu {
        position: relative;
        flex: 1;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 0;
        color: #333333;
        border: none;
      }

      .el-menu-item .li {
        width: 100px;
        margin: 0 auto;
      }

      .el-menu-item .li:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0;
        height: 4px;
        background: #00924c;
        transition: all 0.5s;
      }

      .el-menu-item .li:hover:after {
        width: 100px;
      }

      .el-menu-item.is-active .li:hover:after {
        display: none;
      }

      .el-menu-item .li:hover,
      .el-menu-item .li:focus {
        border-bottom: none !important;
      }

      /deep/ .el-menu-item.is-active .li {
        border-bottom: 4px solid #00924c !important;
      }

      .el-menu-item.is-active .li:hover {
        border-bottom: 4px solid #00924c !important;
      }
    }

    /deep/ .el-submenu.is-active .el-submenu__title {
      width: 100px;
      margin: 0 auto;
      border-width: 4px;
    }

    i {
      font-weight: bold;
    }
  }
}

.header_fixed {
  //position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: white;
  box-shadow: 0px 2px 16px 0px rgba(13, 4, 9, 0.06);
}

.weimu {
  position: fixed;
  top: 120px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
.zhehao {
  top: 158px;
}
// .search:hover.search-box {
//     display: block;
// }
.search-box {
  position: fixed;
  margin: auto;
  top: 80px;
  left: 0;
  right: 0;
  width: 1200px;
  background: #ffffff;
  z-index: 1000;
  //   display: none;
  .search_content {
    padding: 60px 130px;

    h2 {
      font-size: 24px;
      padding-bottom: 30px;
    }

    .keyword {
      padding-top: 26px;
      color: #999999;

      a {
        color: #00924c;
        margin-right: 20px;
      }
    }
  }
}

/deep/
  .search_input
  .el-input
  .el-input-group
  .el-input-group--append
  .el-input-group--prepend {
  border: 1px solid #00924c;
}

//新登录注册
.login_user {
  position: relative;
  .el-button {
    width: 102px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    border-radius: 6px;
    margin-left: 24px;
    .el-divider {
      background: white !important;
    }
  }
}
.login_alert {
  position: absolute;
  right: 0;
  width: 306px;
  padding: 30px;
  background: white;
  border-radius: 0px 0px 6px 6px;
  z-index: 1000;
  .el-button {
    width: 246px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin-left: 0;
    margin-bottom: 24px;
    img {
      width: 18px !important;
      height: 18px !important;
      vertical-align: middle;
      transform: translateY(-1px);
      margin-right: 5px;
    }
  }
  .blue {
    background: #0090e2;
  }
  .org {
    margin-bottom: 0;
    color: white;
    background: #ff9600;
  }
}
</style>
